module.exports = __webpack_public_path__ + "img/1fie-o-bene'bi'alla.1b023f9b.jpg";